import { render } from "./ButtonCenter.vue?vue&type=template&id=07a89b5d&scoped=true"
import script from "./ButtonCenter.vue?vue&type=script&lang=js"
export * from "./ButtonCenter.vue?vue&type=script&lang=js"

import "./ButtonCenter.vue?vue&type=style&index=0&id=07a89b5d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a89b5d"]])

export default __exports__